import styled from 'styled-components'

type ImageSectionProps = {
  leftImage?: string | undefined
  rightImage?: string | undefined
}

const ImageSection = (props: ImageSectionProps) => {
  const { rightImage, leftImage } = props
  const imageSrc = rightImage || leftImage
  return (
    <ImageContainer>
      {imageSrc && (
        <img
          width="100%"
          height="auto"
          src={imageSrc}
          alt="presentation card"
        />
      )}
    </ImageContainer>
  )
}

const ImageContainer = styled.div`
  width: 70%;
  display: flex;
  align-items: center;
  justify-content: center;

  ${({ theme }) => theme.mediaQueries.tabletDown} {
    display: none;
  }
`
export default ImageSection
